import React, { type TouchEventHandler } from 'react'

import type { ImageApiObject } from 'src/types/image'
import styles from './style.module.css'
import { getResponsiveImgProps } from './utils'
import { Image } from '@s4l/uikit'

const mainImageSizes = {
  desktop: {
    size: '580px',
    srcWidth: 580,
  },
  tablet: {
    size: '864px',
    srcWidth: 864,
  },
  mobile: {
    size: '100vw',
    srcWidth: 767,
  },
}

export interface MainImageProps {
  handleClick: (index?: number) => void
  pointerEvents: {
    onTouchEnd: TouchEventHandler<HTMLDivElement>
    onTouchStart: TouchEventHandler<HTMLDivElement>
  }
  photos: ImageApiObject[]
}

const MainImage = ({ handleClick, pointerEvents, photos }: MainImageProps) => {
  const [mainImage] = photos

  return (
    <div className={styles.thumbnail} {...pointerEvents}>
      <Image
        alt="Main Image"
        onClick={() => handleClick(0)}
        {...getResponsiveImgProps(mainImage, mainImageSizes)}
      />
    </div>
  )
}

export default MainImage
